/* eslint-disable react/prop-types */
import PropTypes from 'prop-types'

import Helmet from '@s-ui/react-head'
import AdDisplay from '@adv-mt/mt-ad-display'
import Layout from '@adv-mt/mt-layout-basic'
import ListMakes from '@adv-mt/mt-list-makes'
import ListModels from '@adv-mt/mt-list-models'
import MotorTagCloud from '@adv-mt/mt-list-tagcloud'
import Breadcrumb from '@adv-mt/mt-navigation-breadcrumb'
import SectionWrapper from '@adv-mt/mt-shared-section-wrapper'
import TitleImageTitle from '@adv-mt/mt-technical-detail-make-title'
import MotorTrackingCriteo from '@adv-mt/mt-tracking-criteo'
import TrackingPageView from '@adv-mt/mt-tracking-page-view'

import LinkFactory from '../../../components/LinkFactory/index.js'
import {getInitialProps} from './getInitialProps.js'

const _getBodyTypeListTitle = ({makeName, bodyType, doors, i18n}) => {
  return doors
    ? i18n.t('TECHNICAL_DETAILS_BODY_TYPE_DOORS_MAKE_TITLE', {
        bodyType,
        doors,
        makeName
      })
    : i18n.t('TECHNICAL_DETAILS_BODY_TYPE_MAKE_TITLE', {
        bodyType,
        makeName
      })
}

const _renderBodyTypesDoorsList = ({makeName, models: {modelsList = []} = {}, linkFactory, i18n}) =>
  modelsList.map((group, i) => {
    const {bodyType, doors, models} = group
    const title = _getBodyTypeListTitle({makeName, bodyType, doors, i18n})
    return (
      <SectionWrapper title={title} key={i}>
        <ListModels models={models} linkFactory={linkFactory} />
      </SectionWrapper>
    )
  })

const TechnicalDetailsMake = ({
  breadcrumbs,
  domain,
  filteredMakesList,
  helmet = {},
  i18n,
  makeId,
  makeName,
  makeUrlParam = '',
  models = {},
  pageName,
  tagclouds = [],
  serverErrors,
  loadThirdParties
}) => {
  const make = {id: makeId, name: makeName}
  const config = domain.get('config')
  const {
    ERRORS: {GetModelsGroupedByBodyTypeDoorsVehiclesError}
  } = config.get('COMMON')

  const hasCriticalServerErrors = serverErrors.some(
    serverError => serverError instanceof GetModelsGroupedByBodyTypeDoorsVehiclesError
  )

  return (
    !hasCriticalServerErrors && (
      <Layout.Basic linkFactory={LinkFactory}>
        <TitleImageTitle makeUrlParam={makeUrlParam} makeName={makeName} />
        {_renderBodyTypesDoorsList({
          makeName,
          models,
          linkFactory: LinkFactory,
          i18n
        })}
        <SectionWrapper>
          <MotorTagCloud initialTagclouds={tagclouds} pageName={pageName} makeId={makeId} linkFactory={LinkFactory} />
        </SectionWrapper>
        {filteredMakesList && (
          <SectionWrapper title={i18n.t('TECHNICAL_DETAILS_MAKE_OTHER_MAKES_TITLE')} hasBackground>
            <ListMakes makes={filteredMakesList} linkFactory={LinkFactory} />
          </SectionWrapper>
        )}
        <Breadcrumb items={breadcrumbs} linkFactory={LinkFactory} />
        <Helmet {...helmet} />
        {loadThirdParties && (
          <>
            <TrackingPageView pageName={pageName} make={makeName.toLowerCase()} />
            <AdDisplay pageName={pageName} make={make} />
            <MotorTrackingCriteo />
          </>
        )}
      </Layout.Basic>
    )
  )
}

TechnicalDetailsMake.displayName = 'TechnicalDetailsMake'

TechnicalDetailsMake.propTypes = {
  params: PropTypes.object,
  domain: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired
}

TechnicalDetailsMake.getInitialProps = getInitialProps

export default TechnicalDetailsMake
